/* llm-lightbox — click a product photo (or video) to open it large in a modal with a thumbnail
   strip, prev/next and close. Layers on top of the theme's native HOVER zoom (which stays as-is).

   Images: the native media-gallery.js already preventDefault()s the .js-zoom-link click, so we
   add the modal on that same click; each link's href is the high-res URL.
   Videos / external videos: the theme renders a <deferred-media> with a poster button + a
   <template> holding the real <video>/<iframe>. We intercept the poster click (capture phase, so
   the theme's inline-play doesn't also fire) and play the template markup inside the modal.
   Thumbnails are reused from the existing .media-thumbs rail (videos get a play badge).
   Guarded to do nothing when the theme's OWN lightbox is active (media-gallery[data-zoom-enabled]). */
(function () {
  if (document.documentElement.dataset.llmLbx) return;
  document.documentElement.dataset.llmLbx = '1';

  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var modal, imgEl, videoEl, thumbsEl, prevBtn, nextBtn, closeBtn, dialogEl;
  var slides = [];
  var index = 0;
  var lastFocus = null;

  function build() {
    modal = document.createElement('div');
    modal.className = 'llm-lbx';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="llm-lbx__backdrop" data-close></div>' +
      '<div class="llm-lbx__dialog" role="dialog" aria-modal="true" aria-label="Product image viewer" tabindex="-1">' +
        '<button type="button" class="llm-lbx__btn llm-lbx__close" data-close aria-label="Close">' + ICON_X + '</button>' +
        '<div class="llm-lbx__stage">' +
          '<button type="button" class="llm-lbx__btn llm-lbx__nav llm-lbx__prev" data-prev aria-label="Previous">' + ICON_L + '</button>' +
          '<img class="llm-lbx__img" alt="Product image">' +
          '<div class="llm-lbx__video"></div>' +
          '<button type="button" class="llm-lbx__btn llm-lbx__nav llm-lbx__next" data-next aria-label="Next">' + ICON_R + '</button>' +
        '</div>' +
        '<ul class="llm-lbx__thumbs" role="list"></ul>' +
      '</div>';
    document.body.appendChild(modal);
    imgEl = modal.querySelector('.llm-lbx__img');
    videoEl = modal.querySelector('.llm-lbx__video');
    thumbsEl = modal.querySelector('.llm-lbx__thumbs');
    prevBtn = modal.querySelector('.llm-lbx__prev');
    nextBtn = modal.querySelector('.llm-lbx__next');
    closeBtn = modal.querySelector('.llm-lbx__close');
    dialogEl = modal.querySelector('.llm-lbx__dialog');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-prev]')) return go(index - 1);
      if (e.target.closest('[data-next]')) return go(index + 1);
      var t = e.target.closest('[data-thumb]');
      if (t) return go(parseInt(t.getAttribute('data-thumb'), 10));
      // Keep it open only when clicking the media itself or the thumbnail strip; every other
      // click — the backdrop, the empty space around the media, or the close button — closes.
      if (e.target.closest('.llm-lbx__img') || e.target.closest('.llm-lbx__video') || e.target.closest('.llm-lbx__thumbs')) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowLeft') { go(index - 1); }
      else if (e.key === 'ArrowRight') { go(index + 1); }
      else if (e.key === 'Tab') { trapTab(e); }
    });

    // Swipe left/right inside the modal to change slides (mobile, CVS-style).
    var stage = modal.querySelector('.llm-lbx__stage');
    var sw = null;
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      sw = { x: e.clientX, y: e.clientY };
    }, { passive: true });
    stage.addEventListener('pointerup', function (e) {
      if (!sw) return;
      var dx = e.clientX - sw.x, dy = e.clientY - sw.y;
      sw = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        if (dx < 0) go(index + 1); else go(index - 1);
      }
    }, { passive: true });
  }

  function trapTab(e) {
    var focusables = Array.prototype.filter.call(
      modal.querySelectorAll('button'),
      function (b) { return b.offsetParent !== null; }
    );
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderThumbs() {
    var html = '';
    for (var i = 0; i < slides.length; i++) {
      var badge = slides[i].type === 'image' ? '' : '<span class="llm-lbx__thumb-badge" aria-hidden="true"></span>';
      html += '<li class="llm-lbx__thumb-item">' +
        '<button type="button" class="llm-lbx__thumb' + (slides[i].type === 'image' ? '' : ' llm-lbx__thumb--video') + '" data-thumb="' + i + '" aria-label="View item ' + (i + 1) + '">' +
        badge + '<img src="' + slides[i].thumb + '" alt="Item ' + (i + 1) + '" aria-hidden="true" loading="lazy"></button></li>';
    }
    thumbsEl.innerHTML = html;
    var single = slides.length <= 1;
    thumbsEl.style.display = single ? 'none' : '';
    prevBtn.style.display = single ? 'none' : '';
    nextBtn.style.display = single ? 'none' : '';
  }

  function go(i) {
    if (!slides.length) return;
    index = (i + slides.length) % slides.length;
    var s = slides[index];
    videoEl.innerHTML = ''; // stop any playing video from the previous slide
    if (s.type === 'image') {
      videoEl.style.display = 'none';
      imgEl.style.display = '';
      imgEl.src = s.full;
      imgEl.alt = s.alt || ('Product image ' + (index + 1) + ' of ' + slides.length);
    } else {
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      videoEl.style.display = 'flex';
      videoEl.innerHTML = s.html;
      var v = videoEl.querySelector('video');
      if (v) { try { v.play(); } catch (e) {} }
    }
    var thumbs = thumbsEl.querySelectorAll('.llm-lbx__thumb');
    for (var k = 0; k < thumbs.length; k++) {
      var on = parseInt(thumbs[k].getAttribute('data-thumb'), 10) === index;
      thumbs[k].classList.toggle('is-active', on);
      if (on) { thumbs[k].setAttribute('aria-current', 'true'); if (thumbs[k].scrollIntoView) thumbs[k].scrollIntoView({ block: 'nearest', inline: 'center' }); }
      else { thumbs[k].removeAttribute('aria-current'); }
    }
  }

  function open(list, start) {
    slides = list || [];
    if (!slides.length) return;
    if (!modal) build();
    renderThumbs();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('llm-lbx-open');
    go(start || 0);
    (closeBtn || dialogEl).focus();
  }

  function close() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('llm-lbx-open');
    imgEl.removeAttribute('src');
    videoEl.innerHTML = ''; // stop playback
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  // Collect ALL media slides (images + videos) in gallery order.
  function collect(gallery) {
    var items = gallery.querySelectorAll('.media-viewer__item');
    var arr = [];
    Array.prototype.forEach.call(items, function (item) {
      var type = item.getAttribute('data-media-type');
      if (type !== 'image' && type !== 'video' && type !== 'external_video') return; // skip 3d models
      var mid = item.getAttribute('data-media-id');
      var thumbImg = mid ? gallery.querySelector('.media-thumbs__item[data-media-id="' + mid + '"] img') : null;
      var s = { type: type, mediaId: mid, thumb: '', alt: '' };
      if (type === 'image') {
        var link = item.querySelector('.js-zoom-link');
        var img = item.querySelector('img.product-image') || item.querySelector('img');
        s.full = link ? link.getAttribute('href') : (img ? (img.currentSrc || img.src) : null);
        if (!s.full) return;
        s.alt = (img && img.alt) || '';
        s.thumb = thumbImg ? (thumbImg.currentSrc || thumbImg.src) : s.full;
      } else {
        var tpl = item.querySelector('template');
        s.html = tpl ? tpl.innerHTML : '';
        if (!s.html) return;
        var poster = item.querySelector('.media-poster img');
        s.thumb = thumbImg ? (thumbImg.currentSrc || thumbImg.src) : (poster ? (poster.currentSrc || poster.src) : '');
      }
      arr.push(s);
    });
    return arr;
  }

  function indexByMediaId(mid) {
    for (var i = 0; i < slides.length; i++) { if (slides[i].mediaId === mid) return i; }
    return 0;
  }

  function openFromItem(gallery, item) {
    var list = collect(gallery);
    slides = list;
    open(list, indexByMediaId(item.getAttribute('data-media-id')));
  }

  // Images: click the zoom link (bubble phase — the theme's own preventDefault has already run).
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.js-zoom-link');
    if (!link) return;
    var gallery = link.closest('media-gallery');
    if (!gallery || gallery.hasAttribute('data-zoom-enabled')) return;
    var item = link.closest('.media-viewer__item');
    if (!item || item.getAttribute('data-media-type') !== 'image') return;
    e.preventDefault();
    openFromItem(gallery, item);
  }, false);

  // Videos: intercept the poster click in the CAPTURE phase so the theme's inline <deferred-media>
  // player does not also load, then play the video inside the modal instead.
  document.addEventListener('click', function (e) {
    var poster = e.target.closest('.media-poster');
    if (!poster) return;
    var gallery = poster.closest('media-gallery');
    if (!gallery || gallery.hasAttribute('data-zoom-enabled')) return;
    var item = poster.closest('.media-viewer__item');
    if (!item) return;
    var type = item.getAttribute('data-media-type');
    if (type !== 'video' && type !== 'external_video') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openFromItem(gallery, item);
  }, true);

  // Mobile: the gallery is a swipe slider whose pointer handling suppresses the
  // synthetic click on the image, so the .js-zoom-link handler above never fires
  // on a tap — tapping the photo "did nothing". Detect a genuine tap (touch,
  // minimal movement, not a swipe) on an image slide and open the lightbox
  // directly. Videos are left to the poster handler above.
  var tapStart = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') { tapStart = null; return; }
    var item = e.target.closest && e.target.closest('.media-viewer__item');
    if (!item || !item.closest('media-gallery')) { tapStart = null; return; }
    tapStart = { x: e.clientX, y: e.clientY, t: Date.now(), item: item };
  }, true);
  document.addEventListener('pointerup', function (e) {
    if (!tapStart) return;
    var s = tapStart;
    tapStart = null;
    if (Math.abs(e.clientX - s.x) > 10 || Math.abs(e.clientY - s.y) > 10) return; // swipe, not tap
    if (Date.now() - s.t > 600) return; // long-press, not tap
    var gallery = s.item.closest('media-gallery');
    if (!gallery || gallery.hasAttribute('data-zoom-enabled')) return;
    if (s.item.getAttribute('data-media-type') !== 'image') return;
    // If our modal is already open, ignore (this pointer belongs to the modal's own swipe).
    if (modal && !modal.hidden) return;
    e.preventDefault();
    openFromItem(gallery, s.item);
  }, true);
})();
